import Loader from '@/components/loader'
import { Navigate } from 'react-router-dom'
import { useCustomerAccountAuthentication } from './use-customer-account-authentication.tsx'

interface Props {
  children: React.ReactNode
}

export default function EnsureLogin({ children }: Props) {
  const { isValidating, isAuthenticated } = useCustomerAccountAuthentication()

  if (isValidating) {
    return <Loader />
  }

  if (!isAuthenticated) {
    return <Navigate to='/customer/login' />
  }

  return children
}
